import { ActiveCall } from 'app/models/dto/call.model';

export class PhoneLocaleService {
  phoneNumberLength = 10;

  constructor() {}

  getPhoneNumberFromActiveCall(call: ActiveCall, removePlus: boolean): string {
    let fullPhoneNumber = call.type === 'incoming' ? call.fromNumber : call.toNumber;
    if (/^conference call/i.exec(<string> call.disposition)) {
      fullPhoneNumber = call.toNumber;
    }

    if (removePlus && fullPhoneNumber) {
      fullPhoneNumber = fullPhoneNumber.replace('+', '');
    }
    return fullPhoneNumber ? fullPhoneNumber : '';
  }

  getPhoneCountryCode(phoneNumber: string, removePlus: boolean = false): string {
    phoneNumber = phoneNumber.toString();
    if (!phoneNumber || phoneNumber.length === this.phoneNumberLength) {
      return '';
    } else {
      if (removePlus) {
        return phoneNumber.substr(0, phoneNumber.length - this.phoneNumberLength).replace('+', '');
      } else {
        return phoneNumber.substr(0, phoneNumber.length - this.phoneNumberLength);
      }
    }
  }

  getDisplayPhoneNumber(phoneNumber: string): string {
    phoneNumber = phoneNumber.replace('+', '');
    if (phoneNumber) {
      const tenDigitNumber = phoneNumber.substr(phoneNumber.length - this.phoneNumberLength, this.phoneNumberLength);
      return tenDigitNumber;
    }
    return '';
  }
}
